import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { FC } from 'react';
import countries from 'services/constants/countries-delivery.json';
import { Autocomplete, InputAdornment } from '@mui/material';
import { CountryWithFlag } from 'ui/CountryWithFlag';
import { TCountrySelectProps } from './types';

export const CountrySelectMenu: FC<TCountrySelectProps> = ({
	onChange,
	countryList = countries.map((item) => {
		return { code: item.code, label: item.label };
	}),
	countryCode,
	required = false,
	disabled = false,
	label = 'Country',
}) => {
	const country = countryList.find((item) => item.code === countryCode);

	return (
		<Box sx={{ width: '100%' }}>
			<Autocomplete
				sx={{
					width: '100%',
					'& .MuiInputBase-root': { width: '100%', borderRadius: '12px' },
				}}
				disabled={disabled}
				size="small"
				options={countryList}
				onChange={(event, newValue) => {
					if (newValue) onChange(newValue.code);
				}}
				value={country ?? null}
				autoHighlight
				getOptionLabel={(option) => option.label}
				renderOption={(props, option) => (
					<Box component="li" {...props}>
						<Box
							sx={{
								width: '100%',
								display: 'flex',
								// flexDirection: 'row',
								justifyContent: 'space-between',
								alignItems: 'center',

								'& > div img': { mr: 2, flexShrink: 0 },
							}}
						>
							<Box>
								{/* <img
									loading="lazy"
									width="20"
									srcSet={`https://flagcdn.com/w40/${option.toLowerCase()}.png 2x`}
									src={`https://flagcdn.com/w20/${option.toLowerCase()}.png`}
									alt=""
								/>
								{option} */}
								<CountryWithFlag countryCode={option.code} />
							</Box>
							<Box>{option.code}</Box>
						</Box>
					</Box>
				)}
				renderInput={(params) => (
					<TextField
						{...params}
						disabled={disabled}
						required={required}
						label={label}
						placeholder="Choose a country"
						inputProps={{
							...params.inputProps,
							autoComplete: 'new-password',
							startadornment: (
								<InputAdornment position="start">
									<img
										loading="lazy"
										width="20"
										// srcSet={`https://flagcdn.com/w40/${String(params?.inputProps?.value ?? '')?.toLowerCase()}.png 2x`}
										src={`/img/w20/${String(params?.inputProps?.value ?? '')?.toLowerCase()}.png`}
										alt=""
									/>
								</InputAdornment>
							),
							// value: '',
						}}
					/>
				)}
			/>
		</Box>
	);
};

interface CountryType {
	code: string;
	label: string;
	phone: string;
	suggested?: boolean;
}

// From https://bitbucket.org/atlassian/atlaskit-mk-2/raw/4ad0e56649c3e6c973e226b7efaeb28cb240ccb0/packages/core/select/src/data/countries.js
